import { Button } from 'components/button/Button'
import { PageTitle } from 'components/PageTitle'
import { SideLayout } from 'components/sideLayout/SideLayout'
import { StoreCart } from 'components/store/storeCart/StoreCart'
import { StoreWrapper } from 'components/store/storeContent/StoreContent'
import { StoreSite } from 'components/store/storeSite/StoreSite'
import { WizardProgressHeader } from 'components/wizard/wizardProgressHeader/WizardProgressHeader'
import { GetServerSideProps } from 'next'
import { useTranslation } from 'next-i18next'
import Router, { useRouter } from 'next/router'
import { useStoreCart } from 'utils/cart'
import { GET_STORE_WIZARD_HEADER } from 'utils/constants'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const { t } = useTranslation('device')
  const router = useRouter()
  const cart = useStoreCart()

  return (
    <SideLayout
      header={
        <WizardProgressHeader
          steps={GET_STORE_WIZARD_HEADER()}
          currentStep={GET_STORE_WIZARD_HEADER()[0]?.value}
        />
      }
      rightCss={{ boxShadow: 'var(--card-shadow)' }}
      right={
        <StoreCart>
          {cart?.items && Object.values(cart?.items).length > 0 && (
            <Button type="button" size="large" href="/store/checkout" data-testid="site-checkout">
              {t('device.order_site.rhs_cart_button')}
            </Button>
          )}
        </StoreCart>
      }
    >
      <PageTitle title="Select action" />
      <StoreWrapper>
        <StoreSite
          siteId={router.query.siteId as string}
          onClick={() => Router.push('/store/site')}
        />
      </StoreWrapper>
    </SideLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, ['device', 'pricing_plan'])) } }
}
